import React, {
  useEffect,
  useState,
  useContext,
  useCallback,
  useRef,
} from 'react';
import { Grid, Typography, Button } from '@mui/material';

import SellScreenButtons from './SellScreenButtons';
import SellScreenDescription from './SellScreenDescription';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import { AttachMoney as AttachMoneyIcon } from '@mui/icons-material';

function ModalSellKiosk() {
  const { t } = useTranslation();
  const {
    isLoginRefill,
    updateIsLoginRefill,

    updateShowModalSellKiosk,
    isOKBingoEnabled,
    isWGEnabled,
    vendorInfo,
    sellType,
    userInfo,
    isFullUser,
    userChildren,
    parentInfo,
    currentUser,
    isMultiplier,
    updateIsMultiplier,
    updateRefreshUser,
    updateShowUserInfo,
    updateShowUserInfoSibling,
    updateShowUserInfoOK,
    updateShowUserInfoWG,
    updateShowUserInfoSiblingOK,
    currentTicketOK,
    currentTicketWG,
    ticketSelectedKioskCH,
    ticketSelectedKioskOK,
    ticketSelectedKioskWG,
  } = useContext(AppContext);

  const handleConfirm = () => {
    updateShowModalSellKiosk(false);
  };

  useEffect(() => {
    if (isLoginRefill) {
      updateIsLoginRefill(false);
    }
  }, [isLoginRefill]);

  const [amount, setAmount] = useState('0');
  const [executeConfirm, setExecuteConfirm] = useState(false); //Enter button, send to the component

  const ticketSelectedKioskCHRef = useRef(ticketSelectedKioskCH);
  useEffect(() => {
    ticketSelectedKioskCHRef.current = ticketSelectedKioskCH;
  }, [ticketSelectedKioskCH]);

  const ticketSelectedKioskOKRef = useRef(ticketSelectedKioskOK);
  useEffect(() => {
    ticketSelectedKioskOKRef.current = ticketSelectedKioskOK;
  }, [ticketSelectedKioskOK]);

  const ticketSelectedKioskWGRef = useRef(ticketSelectedKioskWG);
  useEffect(() => {
    ticketSelectedKioskWGRef.current = ticketSelectedKioskWG;
  }, [ticketSelectedKioskWG]);

  //* Check if the current user is a child, to block refill if is not
  const [isCurrentUserChildren, setIsCurrentUserChildren] = useState(false);
  const isCurrentUserChildrenRef = useRef(isCurrentUserChildren);
  useEffect(() => {
    isCurrentUserChildrenRef.current = isCurrentUserChildren;
  }, [isCurrentUserChildren]);

  useEffect(() => {
    if (parentInfo) {
      setIsCurrentUserChildren(true);
      return;
    }
    if (userChildren.length === 0 || !userChildren) {
      setIsCurrentUserChildren(false);
      return;
    }

    const isCurrentUserNotInUserChildren = !userChildren.some(
      (child) => child.ticket7Pincode === currentUser
    );

    setIsCurrentUserChildren(!isCurrentUserNotInUserChildren);
  }, [currentUser, userChildren]);

  useEffect(() => {
    updateRefreshUser(true);
    updateShowUserInfo(false);
    updateShowUserInfoSibling(false);
    updateShowUserInfoOK(false);
    updateShowUserInfoWG(false);
    updateShowUserInfoSiblingOK(false);
  }, []);

  const parentInfoRef = useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);
  const isFullUserRef = useRef(isFullUser);
  useEffect(() => {
    isFullUserRef.current = isFullUser;
  }, [isFullUser]);

  const currentTicketWGRef = useRef(currentTicketWG);
  useEffect(() => {
    currentTicketWGRef.current = currentTicketWG;
  }, [currentTicketWG]);

  const currentTicketOKRef = useRef(currentTicketOK);
  useEffect(() => {
    currentTicketOKRef.current = currentTicketOK;
  }, [currentTicketOK]);

  //* Update amount related
  useEffect(() => {
    if (
      isRefill &&
      !ticketSelectedKioskCHRef.current &&
      vendorInfo.name.slice(0, 9) === 'Clubhouse'
    ) {
      setAmount('0');
      return;
    }

    if (
      isPayoutTicket &&
      sellType === 5 &&
      isFullUserRef.current &&
      !parentInfoRef.current &&
      vendorInfo.name !== 'OK Databingo' &&
      isOKBingoEnabled &&
      vendorInfo.name !== 'WinGames' &&
      isWGEnabled
    ) {
      setAmount('0');
      return;
    }
    if (
      isPayoutTicket &&
      sellType === 5 &&
      amount > parseInt(userInfo.balances.wallet) &&
      vendorInfo.name !== 'OK Databingo' &&
      isOKBingoEnabled &&
      vendorInfo.name !== 'WinGames' &&
      isWGEnabled
    ) {
      setAmount(userInfo.balances.wallet);
      return;
    }

    if (parseInt(amount) > 1000 && (sellType === 14 || sellType === 13)) {
      return;
    }

    if (
      parseInt(amount) > 1000 &&
      ((!isPayoutTicket && sellType !== 2 && sellType !== 5) ||
        (isPayoutTicket && sellType === 6))
    ) {
      setAmount('1000');
      return;
    }

    /*
      if (userInfo.balances) {
        if (parseInt(userInfo.balances.wallet) > 1000 && isPayoutTicket) {
          setAmount(userInfo.balances.wallet);
        }
      }
      */
  }, [amount]);

  const updateAmount = useCallback(
    (value) => {
      if (
        vendorInfo.name === 'OK Databingo' &&
        !currentTicketOKRef.current &&
        (sellType === 5 || sellType === 6)
      ) {
        setAmount('0');
        return;
      }
      if (
        vendorInfo.name === 'OK Databingo' &&
        sellType === 5 &&
        isOKBingoEnabled
      ) {
        return;
      }

      if (
        vendorInfo.name === 'WinGames' &&
        !currentTicketWGRef.current &&
        (sellType === 5 || sellType === 6)
      ) {
        setAmount('0');
        return;
      }

      if (vendorInfo.name === 'WinGames' && sellType === 5 && isWGEnabled) {
        return;
      }

      if (
        isRefill &&
        !ticketSelectedKioskCHRef.current &&
        vendorInfo.name.slice(0, 9) === 'Clubhouse'
      ) {
        setAmount('0');
        return;
      }

      if (
        (amount === 0 || amount === '0') &&
        (value === '0' || value === '00')
      ) {
        setAmount('0');
        return;
      }

      if ((amount === '0' || amount === 0) && value !== 'backspace') {
        setAmount(value);
        return;
      }
      if ((amount === '0' || amount === 0) && value === 'backspace') {
        return;
      }
      if (
        value === 'backspace' &&
        amount.toString().length === 1 &&
        (amount !== '0' || amount !== 0)
      ) {
        setAmount('0');
        return;
      }
      if (
        value === 'backspace' &&
        amount.toString().length > 1 &&
        (amount !== '0' || amount !== 0)
      ) {
        setAmount(amount.toString().substring(0, amount.toString().length - 1));
        return;
      }

      setAmount(amount + value);
    },
    [amount]
  );

  const updateAmountShortcut = (value) => {
    if (!value && value !== 0) {
      return;
    }

    if (
      vendorInfo.name === 'OK Databingo' &&
      !ticketSelectedKioskOKRef.current &&
      (sellType === 5 || sellType === 6)
    ) {
      return;
    }
    if (
      vendorInfo.name === 'WinGames' &&
      !ticketSelectedKioskWGRef.current &&
      (sellType === 5 || sellType === 6)
    ) {
      return;
    }
    if (
      isRefill &&
      !ticketSelectedKioskCHRef.current &&
      vendorInfo.name.slice(0, 9) === 'Clubhouse'
    ) {
      setAmount('0');
      return;
    }
    if (
      isPayoutTicket &&
      sellType === 5 &&
      isFullUserRef.current &&
      !parentInfoRef.current &&
      vendorInfo.name !== 'OK Databingo' &&
      vendorInfo.name !== 'WinGames'
    ) {
      setAmount('0');
      return;
    }

    setAmount(value.toString());
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      // Check if the key pressed is a number
      if (event.key >= '0' && event.key <= '9') {
        updateAmount(event.key);
      } else if (event.key === 'Backspace') {
        updateAmount('backspace');
      } else if (event.key === 'Enter') {
        if (amount !== '0' && amount > 0) {
          //setExecuteConfirm(true);
        }
      }
    };

    // Add event listener for keydown
    window.addEventListener('keydown', handleKeyPress);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [updateAmount]);

  const [description, setDescription] = useState('');
  const [sortDescription, setSortDescription] = useState('');
  const [action, setAction] = useState('');
  const [isRefill, setIsRefill] = useState(false);

  const [sum, setSum] = useState(true);

  const [isShortcut, setIsShorcut] = useState(false); //Shortcuts enable, type 1,2,3,6
  const [isTicketCH, setIsTicketCH] = useState(false); //Multipliers enable
  const [isPayoutTicket, setIsPayoutTicket] = useState(false); //Multipliers enable
  const [isUserSaldo, setIsUserSaldo] = useState(false); //Multipliers enable

  useEffect(() => {
    if (vendorInfo.name.slice(0, 9) === 'Clubhouse') {
      setDescription('Clubhouse');
      setSortDescription('CH');
    } else if (vendorInfo.name === 'OK Databingo') {
      setDescription('OK Databingo');
      setSortDescription('OK D.');
    } else if (vendorInfo.name === 'WinGames') {
      setDescription('WinGames');
      setSortDescription('WG');
    } else if (vendorInfo.name === 'Norsk Tipping') {
      setDescription('Norsk Tipping');
      setSortDescription('NT');
    }

    switch (sellType) {
      case 1:
        setAction('Sett inn');
        setSum(true);
        setIsShorcut(true);
        setIsPayoutTicket(false);
        setIsUserSaldo(false);
        break;
      case 2:
        setAction('Ta ut');
        setSum(false);
        setIsShorcut(false);
        setIsPayoutTicket(false);
        setIsUserSaldo(true);
        break;
      case 3:
        setAction('Ny Billett');
        setSum(true);
        setIsShorcut(true);
        setIsPayoutTicket(false);
        setIsUserSaldo(false);
        break;
      case 4:
        setAction('Ny Billett');
        setSum(true);
        setIsShorcut(true);
        setIsPayoutTicket(false);
        setIsUserSaldo(false);
        break;
      case 5:
        setAction('Utbetaling');
        setSum(false);
        setIsShorcut(false);
        setIsPayoutTicket(false);
        setIsUserSaldo(false);
        break;
      case 6:
        setAction('Fylle på');
        setSum(true);

        setIsShorcut(true);
        setIsPayoutTicket(false);
        setIsUserSaldo(false);

        break;
      case 13:
        setAction('Inn');
        setSum(true);
        setIsShorcut(true);
        setIsPayoutTicket(false);
        setIsUserSaldo(false);
        break;

      case 14:
        setAction('Ut');
        setSum(false);
        setIsShorcut(true);
        setIsPayoutTicket(false);
        setIsUserSaldo(false);
        break;
      case 24:
        setAction('Ny Billett');
        setSum(true);
        setIsShorcut(true);
        setIsPayoutTicket(false);
        setIsUserSaldo(false);
        break;
      case 25:
        setAction('Utbetaling');
        setSum(false);
        setIsShorcut(false);
        setIsPayoutTicket(true);
        setIsUserSaldo(false);
        break;
      case 26:
        setAction('Fylle på');
        setSum(true);
        setIsShorcut(true);
        setIsPayoutTicket(true);
        setIsUserSaldo(false);
        break;
      default:
        break;
    }

    if (sellType === 6 || sellType === 26) {
      setIsRefill(true);
    } else {
      setIsRefill(false);
    }

    if (vendorInfo.name === 'OK Databingo' && !isOKBingoEnabled) {
      setIsShorcut(false);
      setIsRefill(false);
    }
    if (vendorInfo.name === 'WinGames' && !isWGEnabled) {
      setIsShorcut(false);
      setIsRefill(false);
    }

    if (vendorInfo.name.slice(0, 9) === 'Clubhouse' && sellType === 3) {
      setIsTicketCH(true);
    }
    if (
      vendorInfo.name.slice(0, 9) === 'Clubhouse' &&
      (sellType === 5 || sellType === 6)
    ) {
      setIsPayoutTicket(true);
      //Search for amount to fulfilled the pay out
      if (
        (isFullUser && vendorInfo.name.slice(0, 9) === 'Clubhouse') ||
        sellType === 6
      ) {
        return;
      }
      setAmount(userInfo.balances ? userInfo.balances.wallet : 0);
    }
    if (
      vendorInfo.name === 'OK Databingo' &&
      (sellType === 5 || sellType === 6)
    ) {
      setIsPayoutTicket(true);
    }

    if (vendorInfo.name === 'WinGames' && (sellType === 5 || sellType === 6)) {
      setIsPayoutTicket(true);
    }
  }, []);

  const accent = '#FFC727';
  const glassBg = 'rgba(255,255,255,0.06)';
  const glassBorder = '1px solid rgba(255,255,255,0.14)';
  const multiplierOptions = [1, 2, 3, 4, 5, 10];

  return (
    <div id="react-confirm-alert ">
      <div
        className="react-confirm-alert-overlay react-confirm-alert-overlay-kiosk"
        style={{
          background: 'rgba(3,6,18,0.88)',
          padding: '24px 16px',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          overflowY: 'auto',
        }}
      >
        <div
          className="react-confirm-alert"
          style={{
            width: 'min(1280px, 96vw)',
            height: 'min(1220px, 92vh)',
            borderRadius: '24px',
            overflow: 'hidden',
            border: '1px solid rgba(255,255,255,0.12)',
            boxShadow: '0 30px 90px rgba(0,0,0,0.65)',
            background:
              'linear-gradient(135deg, rgba(18,26,55,0.98), rgba(10,14,28,0.98))',
          }}
        >
          <div style={{ width: '100%', padding: 0, height: '100%' }}>
            <Grid
              container
              sx={{
                height: '100%',
                flexDirection: 'column',
                flexWrap: 'nowrap',
              }}
            >
              {/* HEADER */}
              <Grid
                item
                xs="auto"
                sx={{
                  height: 120,
                  flexShrink: 0,
                  borderBottom: '1px solid rgba(255,255,255,0.10)',
                  background:
                    'linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))',
                }}
              >
                <div
                  style={{
                    height: '100%',
                    padding: '0 18px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '12px',
                  }}
                >
                  {/* Left: title */}
                  <Typography
                    sx={{
                      color: 'white',
                      fontSize: '26px',
                      fontWeight: 900,
                      lineHeight: 1,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {action}{' '}
                    <span
                      style={{
                        color: 'rgba(255,255,255,0.45)',
                        fontWeight: 700,
                      }}
                    >
                      · {vendorInfo?.name}
                    </span>
                  </Typography>

                  {/* Right: multipliers or saldo */}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    {description === 'Clubhouse' && action === 'Ny Billett' && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '10px 12px',
                          borderRadius: '999px',
                          border: glassBorder,
                          background: glassBg,
                        }}
                      >
                        {multiplierOptions.map((value) => {
                          const isSelected = isMultiplier === value;
                          return (
                            <Button
                              key={value}
                              onClick={() => updateIsMultiplier(value)}
                              sx={{
                                minWidth: 90,
                                height: 76,
                                padding: '0 8px',
                                borderRadius: '999px',
                                border: isSelected
                                  ? `1px solid ${accent}`
                                  : '1px solid rgba(255,255,255,0.18)',
                                background: isSelected
                                  ? `${accent}22`
                                  : 'rgba(255,255,255,0.06)',
                                color: 'white',
                                fontWeight: 800,
                                fontSize: '25px',
                                letterSpacing: '0.04em',
                                textTransform: 'uppercase',
                                boxShadow: 'none',
                                '&:hover': {
                                  background: isSelected
                                    ? `${accent}33`
                                    : 'rgba(255,255,255,0.12)',
                                  boxShadow: 'none',
                                },
                              }}
                            >
                              x{value}
                            </Button>
                          );
                        })}
                      </div>
                    )}

                    {isUserSaldo &&
                      userInfo?.balances?.wallet !== undefined && (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '4px 10px',
                            borderRadius: '999px',
                            border: glassBorder,
                            background: glassBg,
                          }}
                        >
                          <AttachMoneyIcon
                            sx={{ fontSize: 15, color: 'white' }}
                          />
                          <span
                            style={{
                              color: 'white',
                              fontWeight: 900,
                              fontSize: '13px',
                            }}
                          >
                            Saldo&nbsp;{userInfo.balances.wallet}
                          </span>
                        </div>
                      )}
                  </div>
                </div>
              </Grid>

              {/* CONTENT */}
              <Grid
                item
                xs={12}
                sx={{
                  flex: 1,
                  minHeight: 0,
                  padding: '14px 18px 18px 18px',
                }}
              >
                {/* No-tabs layout: single full-width column */}
                {!(isShortcut && isPayoutTicket) && (
                  <Grid container spacing={2} sx={{ height: '100%' }}>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                      }}
                    >
                      {/* Content panel */}
                      <div
                        style={{
                          flex: 1,
                          minHeight: 0,
                          borderRadius: '20px',
                          border: glassBorder,
                          background: glassBg,
                          overflow: 'hidden',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <div
                          style={{
                            padding: '12px 14px',
                            borderBottom: '1px solid rgba(255,255,255,0.10)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexShrink: 0,
                          }}
                        >
                          <Typography
                            sx={{
                              color: 'white',
                              fontWeight: 900,
                              fontSize: '18px',
                              letterSpacing: '0.14em',
                              textTransform: 'uppercase',
                            }}
                          >
                            {isPayoutTicket
                              ? t('sales.payoutTicket')
                              : isShortcut
                                ? t('sales.shortcuts')
                                : description}
                          </Typography>
                          <div
                            style={{
                              color: 'rgba(255,255,255,0.65)',
                              fontWeight: 800,
                              fontSize: 12,
                            }}
                          >
                            {action}
                          </div>
                        </div>

                        <div
                          style={{ flex: 1, minHeight: 0, overflow: 'auto' }}
                        >
                          <SellScreenDescription
                            amount={amount}
                            description={description}
                            action={action}
                            isShortcut={isShortcut}
                            isPayoutTicket={isPayoutTicket}
                            updateAmountShortcut={updateAmountShortcut}
                            isUserSaldo={isUserSaldo}
                            isRefill={isRefill}
                            tabValue={undefined}
                          />
                        </div>
                      </div>

                      {/* Actions */}
                      <div
                        style={{
                          flexShrink: 0,
                          borderRadius: '20px',
                          border: glassBorder,
                          background: glassBg,
                          padding: '8px 10px',
                        }}
                      >
                        <SellScreenButtons
                          amount={amount}
                          sum={sum}
                          sortDescription={sortDescription}
                          action={action}
                          executeConfirm={executeConfirm}
                        />
                      </div>
                    </Grid>
                  </Grid>
                )}

                {/* Tabs layout: list left, shortcuts right, actions below both */}
                {isShortcut && isPayoutTicket && (
                  <div
                    style={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '16px',
                    }}
                  >
                    {/* Two panels side by side */}
                    <div
                      style={{
                        flex: 1,
                        minHeight: 0,
                        display: 'flex',
                        gap: '16px',
                      }}
                    >
                      {/* Left: payout ticket list */}
                      <div
                        style={{
                          flex: 1,
                          minWidth: 0,
                          borderRadius: '20px',
                          border: glassBorder,
                          background: glassBg,
                          overflow: 'hidden',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <div
                          style={{
                            padding: '12px 14px',
                            borderBottom: '1px solid rgba(255,255,255,0.10)',
                            flexShrink: 0,
                          }}
                        >
                          <Typography
                            sx={{
                              color: 'white',
                              fontWeight: 900,
                              fontSize: '18px',
                              letterSpacing: '0.14em',
                              textTransform: 'uppercase',
                            }}
                          >
                            {t('sales.payoutTicket')}
                          </Typography>
                        </div>
                        <div
                          style={{ flex: 1, minHeight: 0, overflow: 'auto' }}
                        >
                          <SellScreenDescription
                            amount={amount}
                            description={description}
                            action={action}
                            isShortcut={isShortcut}
                            isPayoutTicket={isPayoutTicket}
                            updateAmountShortcut={updateAmountShortcut}
                            isUserSaldo={isUserSaldo}
                            isRefill={isRefill}
                            tabValue={0}
                          />
                        </div>
                      </div>

                      {/* Right: shortcuts */}
                      <div
                        style={{
                          flex: 1,
                          minWidth: 0,
                          borderRadius: '20px',
                          border: glassBorder,
                          background: glassBg,
                          overflow: 'hidden',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <div
                          style={{
                            padding: '12px 14px',
                            borderBottom: '1px solid rgba(255,255,255,0.10)',
                            flexShrink: 0,
                          }}
                        >
                          <Typography
                            sx={{
                              color: 'white',
                              fontWeight: 900,
                              fontSize: '18px',
                              letterSpacing: '0.14em',
                              textTransform: 'uppercase',
                            }}
                          >
                            {t('sales.shortcuts')}
                          </Typography>
                        </div>
                        <div
                          style={{ flex: 1, minHeight: 0, overflow: 'auto' }}
                        >
                          <SellScreenDescription
                            amount={amount}
                            description={description}
                            action={action}
                            isShortcut={isShortcut}
                            isPayoutTicket={isPayoutTicket}
                            updateAmountShortcut={updateAmountShortcut}
                            isUserSaldo={isUserSaldo}
                            isRefill={isRefill}
                            tabValue={1}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Actions — full width below both panels */}
                    <div
                      style={{
                        flexShrink: 0,
                        borderRadius: '20px',
                        border: glassBorder,
                        background: glassBg,
                        padding: '8px 10px',
                      }}
                    >
                      <SellScreenButtons
                        amount={amount}
                        sum={sum}
                        sortDescription={sortDescription}
                        action={action}
                        executeConfirm={executeConfirm}
                      />
                    </div>
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalSellKiosk;
